import { Injectable } from '@angular/core';
import { Http, Weaver, Wrapper } from '@skylab-angular-shared/core';
import { AccountancyRepositoryBase } from '@skylab-shared/business';
export { AccountancyRepositoryBase };

@Injectable({ providedIn: 'root'})
@Wrapper(AccountancyRepositoryBase)
export class AccountancyRepository {
    public constructor(
        http: Http,
        weaver: Weaver,
    ) { }
}
